import React from 'react';

import { RichText } from '../RichText/RichText';

type OverviewProps = {
    description: string | null;
    benefits: string[];
};

export function Overview(props: OverviewProps) {
    const { description, benefits } = props;
    const hasDesc = description && description !== '<BR>';
    return (
        <>
            {hasDesc && <RichText content={description!} />}
            {benefits.length > 0 && (
                <>
                    {hasDesc && <br />}
                    <h3 className="h2">Benefits</h3>
                    <ul>
                        {benefits.map((benefit) => (
                            <li key={benefit}>{benefit}</li>
                        ))}
                    </ul>
                </>
            )}
        </>
    );
}
